<app-dialog-simple
  [textContent]="{
    title: 'propriete.photo.erreur.titre',
    titleId: 'popup-titre',
    paragraph: errorMessageIdentifier,
    paragraphId: 'popup-texte',
    confirmButton: 'btn.ok'
  }"
  (close)="close()"
  (confirm)="close()"
  icon="assets/images/icon-error-message.svg"
>
</app-dialog-simple>
